import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";
import CreditCard from "@insite/mobius/Icons/CreditCard";
import { css } from "styled-components";

viewStyles.noPaymentsIconWrapper = {
    css: css`
        height: 120px;
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};
viewStyles.noPaymentsIcon = {
    src: CreditCard,
    color: "common.accent",
    size: 75,
};
viewStyles.noPaymentsWrapper = {
    css: css`
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    `,
};
